<template>
    <div class="profile-container">
      <el-card class="profile-card">
        <!-- 个人信息头部 -->
        <div class="profile-header">
          <div class="avatar-container">
            <img  :src= "imageUrl+userInfo.avatar || ''" class="avatar">
          </div>
          <div class="user-info">
            <h2>{{ userInfo.nickname || userInfo.username }}</h2>
            <p class="username">@{{ userInfo.username }}</p>
            <el-button 
              size="small" 
              type="primary" 
              @click="showEditDialog">
              编辑资料
            </el-button>
          </div>
        </div>
  
        <!-- 个人信息详情 -->
        <div class="profile-details">
          <el-row :gutter="20">
            <el-col>
              <div class="detail-item">
                <div class="detail-label">注册时间</div>
                <div class="detail-value">{{ userInfo.createTime | formatDate }}</div>
              </div>
            </el-col>
            <el-col>
              <div class="detail-item">
                <div class="detail-label">最后登录</div>
                <div class="detail-value">{{ userInfo.lastLoginTime | formatDate }}</div>
              </div>
            </el-col>
            
          </el-row>
        </div>
  
        <!-- 选项卡 -->
        <el-tabs v-model="activeTab" class="profile-tabs">
          <el-tab-pane label="账号安全" name="basic">
            <div class="security-section">
              <el-alert
                title="账号安全提示"
                type="info"
                :closable="false"
                show-icon>
                定期修改密码可以提高账号安全性
              </el-alert>
              
              <div class="security-item">
                <div class="security-info">
                  <span class="security-label">登录密码</span>
                  <span class="security-value">********</span>
                </div>
                <el-button size="small" @click="showPasswordDialog">修改密码</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
  
      <!-- 编辑资料对话框 -->
      <el-dialog title="编辑资料" :visible.sync="editDialogVisible" :width="dialogWidth">
        <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px">
          <!-- <el-form-item label="头像">
            <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-change="handleAvatarChange"
              action=""
              accept="image/jpeg,image/png"
              auto-upload="false">
              <img v-if="editForm.avatar" :src="imageUrl+editForm.avatar" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->

          <el-form-item label="头像" prop="cover">
              <el-upload
              class="avatar-uploader"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-change="handleAvatarChange"
              action="#"
              accept="image/jpeg,image/png"
              :auto-upload="false"
              >
                <img 
              v-if="editForm.avatar" 
              :src="isLocalPath(editForm.avatar) ? editForm.avatar : imageUrl+editForm.avatar" 
              class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          <el-form-item label="昵称" prop="nickname">
            <el-input v-model="editForm.nickname" placeholder="请输入昵称"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEditForm">保 存</el-button>
        </span>
      </el-dialog>
  
      <!-- 修改密码对话框 -->
      <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" :width="dialogWidth">
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
          <el-form-item label="原密码" prop="oldPassword">
            <el-input 
              type="password" 
              v-model="passwordForm.oldPassword" 
              placeholder="请输入原密码"
              show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input 
              type="password" 
              v-model="passwordForm.newPassword" 
              placeholder="请输入新密码"
              show-password></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input 
              type="password" 
              v-model="passwordForm.confirmPassword" 
              placeholder="请再次输入新密码"
              show-password></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="passwordDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPasswordForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserProfile',
    data() {
      // 验证确认密码
      const validateConfirmPassword = (rule, value, callback) => {
        if (value !== this.passwordForm.newPassword) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      }
  
      return {
        activeTab: 'basic',
        selectedFile: null,
        uploadHeaders: {
          Authorization: `Bearer ${localStorage.getItem('isAuthenticated')}`,
          'Content-Type': 'multipart/form-data'
        },
        userInfo: {
          username: '',
          nickname: '',
          avatar: '',
          createTime: '',
          lastLoginTime: ''
        },
        editDialogVisible: false,
        editForm: {
          avatar: '',
          nickname: ''
        },
        editRules: {
          nickname: [
            { required: true, message: '请输入昵称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],
        },
        passwordDialogVisible: false,
        passwordForm: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        passwordRules: {
          oldPassword: [
            { required: true, message: '请输入原密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请确认新密码', trigger: 'blur' },
            { validator: validateConfirmPassword, trigger: 'blur' }
          ]
        },
        phoneDialogVisible: false,
        phoneForm: {
          phone: '',
          code: ''
        },
        emailDialogVisible: false,
        codeCountdown: 0,
        emailCodeCountdown: 0,
        codeTimer: null,
        emailCodeTimer: null,
            // 响应式相关数据
   screenWidth: window.innerWidth
      }
    },
    filters: {
      formatDate(value) {
        if (!value) return '未知'
        const date = new Date(value)
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      },
    },
    created() {
      this.fetchUserInfo()
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      if (this.codeTimer) clearInterval(this.codeTimer)
      if (this.emailCodeTimer) clearInterval(this.emailCodeTimer)
      window.removeEventListener('resize', this.handleResize);
    },
    computed:{
 // 判断是否为桌面设备
 isDesktop() {
      return this.screenWidth >= 1024;
    },
    // 对话框宽度
    dialogWidth() {
      return this.screenWidth < 768 ? '100%' : '35%';
    },
  },
    methods: {
        // 处理窗口大小变化
        handleResize() {
      this.screenWidth = window.innerWidth;
    },
      handleUploadError(err) {
    console.error('上传失败:', err);
    this.$message.error('头像上传失败');
  },
     // 获取用户信息
      fetchUserInfo() {
        this.$http.get('/api/adminAuth/profile')
          .then(response => {
            this.userInfo = response.data.data;
            console.log('用户信息',this.userInfo)
            this.resetEditForm();
          })
          .catch(error => {
            console.error('获取用户信息失败:', error);
            this.$message.error('获取用户信息失败');
          });
      },
      
      // 显示编辑对话框
      showEditDialog() {
        this.editDialogVisible = true
      },
      
      // 重置编辑表单
      resetEditForm() {
        this.editForm = {
          avatar: this.userInfo.avatar,
          nickname: this.userInfo.nickname
        }
      },
      
      // 提交编辑表单
      submitEditForm() {
    this.$refs.editForm.validate(valid => {
      if (valid) {
        if (this.selectedFile) {
          // 如果有新头像，先上传头像
          this.uploadAvatar()
          this.saveProfile()
        } else {
          // 没有新头像，直接保存资料
          this.saveProfile()
        }
      }
    })
  },
  isLocalPath(url) {
    return url.startsWith('data:') || url.startsWith('blob:');
  },
  saveProfile() {
    this.$http.put('/api/adminAuth/profile', {
      nickname: this.editForm.nickname,
      avatar: this.editForm.avatar
    })
    .then(response => {
      this.$message.success(response.data.message)
      this.fetchUserInfo()
      this.editDialogVisible = false
      this.$bus.$emit('update-user-info', 1)
    })
    .catch(error => {
      console.error('更新资料失败:', error)
      this.$message.error(error.response?.data?.message || '更新资料失败')
    })
  },
      
      // 头像上传成功
      handleAvatarSuccess(res, file) {
        console.log('上传成功:', res);
      if (res.success) {
        this.userInfo.avatar = res.data.avatar;
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
      
      // 编辑对话框头像上传成功
      handleEditAvatarSuccess(res, file) {
        console.log('上传成功:', res);
        if (res.success) {
          this.editForm.avatar = res.data.avatar;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      },
      handleAvatarChange(file) {
    this.selectedFile = file
    const reader = new FileReader()
    reader.onload = (e) => {
      this.editForm.avatar = e.target.result
    }
    reader.readAsDataURL(file.raw)
  },
  uploadAvatar() {
    if (!this.selectedFile) {
      this.$message.warning('请先选择头像图片')
      return
    }
    
    const formData = new FormData()
    formData.append('file', this.selectedFile.raw)
    
    this.$http.post('/api/adminAuth/upload/avatar', formData)
    .then(response => {
      if (response.data.success) {
        this.$message.success('头像上传成功')
        this.editForm.avatar = response.data.data.avatar
        this.fetchUserInfo() // 刷新用户信息
      } else {
        this.$message.error(response.data.message)
      }
    })
    .catch(error => {
      console.error('头像上传失败:', error)
      this.$message.error('头像上传失败')
    })
  },
      
      // 头像上传前校验
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2
  
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },
      
      // 显示修改密码对话框
      showPasswordDialog() {
        this.passwordDialogVisible = true
        this.$nextTick(() => {
          this.$refs.passwordForm && this.$refs.passwordForm.resetFields()
        })
      },
      
      // 提交修改密码表单
      submitPasswordForm() {
        this.$refs.passwordForm.validate(valid => {
          if (valid) {
            this.$http.put('/api/adminAuth/password', {
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword
            })
            .then(response => {
              this.$message.success(response.data.message);
              this.passwordDialogVisible = false;
              this.$refs.passwordForm.resetFields();
            })
            .catch(error => {
              console.error('修改密码失败:', error);
              this.$message.error(error.response?.data?.message || '修改密码失败');
            });
          }
        });
      },
    }
  }
  </script>
  
  <style scoped>
  .profile-container {
    /* padding: 20px; */
  }
  
  .profile-card {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .profile-header {
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .avatar-container {
    position: relative;
    margin-right: 30px;
  }
  .avatar-container .avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: block;
  }
  .avatar-uploader {
    position: relative;
    display: inline-block;
  }
  
  .avatar-uploader .avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: block;
  }
  
  .avatar-uploader-icon {
    font-size: 60px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border-radius: 50%;
    background-color: #f5f7fa;
    border: 1px dashed #d9d9d9;
  }
  
  .avatar-edit-hint {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 36px;
    height: 36px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
  }
  
  .user-info h2 {
    margin: 0;
    font-size: 24px;
    color: #303133;
  }
  
  .user-info .username {
    margin: 5px 0;
    color: #909399;
    font-size: 14px;
  }
  
  .user-info .bio {
    margin: 10px 0;
    color: #606266;
    max-width: 500px;
  }
  
  .profile-details {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .detail-item {
    padding: 10px;
  }
  
  .detail-label {
    color: #909399;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .detail-value {
    color: #303133;
    font-size: 16px;
  }
  
  .profile-tabs {
    padding: 0 20px;
  }
  
  .info-section {
    padding: 20px 0;
  }
  
  .security-section {
    padding: 20px 0;
  }
  
  .security-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #ebeef5;
  }
  
  .security-info {
    display: flex;
    flex-direction: column;
  }
  
  .security-label {
    color: #909399;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .security-value {
    color: #303133;
    font-size: 16px;
  }
  
  .code-input {
    display: flex;
  }
  
  .code-input .el-input {
    flex: 1;
    margin-right: 10px;
  }
  </style>